<template>
  <draggable
    v-model="sortableImages"
    class="p-imageCard__block"
    ghost-class="ghost"
    handle=".p-imageCard__handle"
    :force-fallback="true"
    :scroll-sensitivity="150"
    tag="v-row"
    :animation="200"
  >
    <template v-for="(image, index) in sortableImages">
      <!-- <v-col v-if="!image.deleted" :key="index" cols="4" class="dragImage"> -->
      <div v-if="!image.deleted" :key="index" class="dragImage">
        <div class="p-imageCard__wrap">
          <v-card class="p-imageCard__handle">
            <div class="p-imageCard__removeBtn" @click="removeImage(index)">
              <v-icon medium>mdi-close</v-icon>
            </div>
            <!-- <v-img
              class="p-imageCard"
              :src="image.previewUrl"
              min-height="200"
              max-height="250"
              max-width="250"
            > -->
            <v-img
              class="p-imageCard"
              :src="image.previewUrl"
              height="150"
              width="150"
            >
              <span class="p-imageCard__priority">
                {{ index + 1 }}
              </span>
            </v-img>
          </v-card>
          <v-text-field
            :value="assignAltAttribute(image)"
            label="alt属性"
            @input="(inputValue) => (image.altAttribute = inputValue)"
          />
        </div>
      </div>
    </template>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'SortImages',
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      sortableImages: this.value
    }
  },
  watch: {
    sortableImages () {
      this.$emit('change', this.sortableImages)
    }
  },
  methods: {
    removeImage (index) {
      this.sortableImages[index].deleted = true
    },
    assignAltAttribute (image) {
      if (!image.altAttribute) this.$set(image, 'altAttribute', '')

      return image.altAttribute
    }
  }
}
</script>
<style>
.p-imageCard__block {
  counter-reset: priority;
  display: flex;
  padding-left: 30px;
}

.dragImage {
  width: 150px;
  margin-right: 20px;
}

.p-imageCard__wrap {
  min-height: 270px;
  cursor: grab;
}

.ghost {
  opacity: 0;
}

.p-imageCard__priority {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 25px;
  height: 25px;
  text-align: center;
  background-color: #ddd;
  font-weight: bold;
}

.p-imageCard__wrap:hover .p-imageCard__removeBtn {
  display: block;
  cursor: pointer;
}

.p-imageCard__removeBtn {
  display: none;
  position: absolute;
  color: #000;
  background-color: #fff;
  right: 0;
  top: 0;
  z-index: 1;
  height: 26px;
  width: 26px;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
</style>
